export const ARTICLE_RESPONSIVE_IMAGE_SIZES = '100vw';

export const COMMON_RESPONSIVE_IMAGE_SIZES = '100vw';
